/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum TextBlockTypeEnum {
  TextBlock = 'text_block',
}

export function instanceOfTextBlockTypeEnum(value: any): boolean {
  for (const key in TextBlockTypeEnum) {
    if (Object.prototype.hasOwnProperty.call(TextBlockTypeEnum, key)) {
      if (TextBlockTypeEnum[key as keyof typeof TextBlockTypeEnum] === value) {
        return true
      }
    }
  }
  return false
}

export function TextBlockTypeEnumFromJSON(json: any): TextBlockTypeEnum {
  return TextBlockTypeEnumFromJSONTyped(json, false)
}

export function TextBlockTypeEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TextBlockTypeEnum {
  return json as TextBlockTypeEnum
}

export function TextBlockTypeEnumToJSON(value?: TextBlockTypeEnum | null): any {
  return value as any
}
